import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-aue-link',
  templateUrl: './aue-link.component.html',
  styleUrls: ['./aue-link.component.scss']
})
export class AueLinkComponent implements OnInit {
  aueLinkUrl: string = "";
  aueTextBeginning: string = "";
  aueLinkText: string = "";
  aueTextEnd: string = "";

  constructor(private confSvc: ConfigService) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();

    this.aueLinkUrl = this.confSvc.getString("aueLinkUrl");
    this.aueTextBeginning = this.confSvc.getString("aueTextBeginning");
    this.aueLinkText = this.confSvc.getString("aueLinkText");
    this.aueTextEnd = this.confSvc.getString("aueTextEnd");
  }

}
